import { ReactElement, useState } from 'react';
import DropdownCustom from '../../controls/DropdownCustom';
import {
  GatewayDetails,
  ActionData,
  Option,
  ActionsTypes
} from '../../constants/telosair-interfaces';

const options: Option<ActionsTypes>[] = [
  { name: 'Edit device', id: 'edit' },
  { name: 'Delete device', id: 'delete' }
];

type GatewayProps = {
  gateway: GatewayDetails;
  handleGatewayAction: (data: ActionData<GatewayDetails>) => void;
};

/**
 * A Gateway Row Component that will render its details.
 * @param props - Properties of Gateway component.
 * @returns - A react Element.
 */
export default function GatewayRow(props: GatewayProps): ReactElement {
  const { gateway, handleGatewayAction } = props;
  const [showMoreDevice, setShowMoreDevice] = useState(false);

  /**
   * Function to handle action.
   * @param type - Type of the action edit or delete.
   */
  const onSelect = (type: ActionsTypes): void => {
    handleGatewayAction({ type, data: gateway });
  };
  return (
    <>
      <tr className="bg-white dark:bg-container-500 text-gray-500 dark:text-gray-300 border-b border-b-gray-300 dark:border-b-gray-900">
        <td className="w-[20%]">
          <div
            role="button"
            tabIndex={0}
            className="cursor-pointer h-11 px-2 sm:px-6 py-4 inline-flex justify-center items-center gap-x-1.5"
            onClick={() => setShowMoreDevice(!showMoreDevice)}
            onKeyDown={() => setShowMoreDevice(!showMoreDevice)}
          >
            <span style={{ color: '#F67B04' }} className="material-icons-outlined text-sm mr-1">
              router
            </span>
            {gateway.gatewayName}
            <span className="material-icons-outlined text-gray-700 dark:text-gray-400">
              {showMoreDevice ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
            </span>
          </div>
        </td>

        <td className="w-[13%] py-3 text-center">{gateway.gatewayId}</td>
        <td className="w-[13%] py-3 text-center">
          -<div className="text-success-500 text-xs font-normal py-1">All Active</div>
        </td>
        <td className="w-[13%] py-3 text-center">-</td>
        <td className="w-[13%] py-3 text-center">{gateway.softwareVersion}</td>
        <td className="w-[13%] py-3 text-center">-</td>

        <td className="w-[15%] py-3 text-center">
          <DropdownCustom<ActionsTypes>
            onClick={onSelect}
            controlPlaceholder="Action"
            buttons={options}
          />
        </td>
      </tr>

      {showMoreDevice && (
        <div className="text-center p-4">
          <p className="text-center">No Devices</p>
        </div>
      )}
    </>
  );
}
